var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("@/assets/images/active/active20230406/1.png"),"alt":""}}),_c('div',{staticClass:"btn-box flex"},[_c('div',{staticClass:"btn",on:{"click":_vm.toNextPage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }